<template>
    <div>

        <Head :title="__(title)" />
        <div class="max-w-full bg-white rounded-md shadow overflow-hidden">
            <form @submit.prevent="store">
                <div class="flex flex-wrap -mb-8 -mr-6 p-8">
                    <text-input v-model="form.first_name" :error="form.errors.first_name"
                        class="pb-8 pr-6 w-full lg:w-1/3" :label="__('First name')" />
                    <text-input v-model="form.last_name" :error="form.errors.last_name"
                        class="pb-8 pr-6 w-full lg:w-1/3" :label="__('Last name')" />
                    <text-input v-model="form.email" :error="form.errors.email" class="pb-8 pr-6 w-full lg:w-1/3"
                        :label="__('Email')" />
                    <text-input v-model="form.phone" :error="form.errors.phone" class="pb-8 pr-6 w-full lg:w-1/2"
                        :label="__('Phone')" />
                    <text-input v-model="form.city" :error="form.errors.city" class="pb-8 pr-6 w-full lg:w-1/2"
                        :label="__('City')" />
                    <text-input v-model="form.address" :error="form.errors.address" class="pb-8 pr-6 w-full lg:w-1/3"
                        :label="__('Address')" />

                    <select-input v-model="form.country_id" :error="form.errors.country_id"
                        class="pr-6 pb-8 w-full lg:w-1/3" :label="__('Country')">
                        <option :value="null" />
                        <option v-for="c in countries" :key="c.id" :value="c.id">{{ __(c.name) }}</option>
                    </select-input>

                    <!-- Add Department Select -->
                    <select-input v-model="form.department_id" :error="form.errors.department_id"
                        class="pr-6 pb-8 w-full lg:w-1/3" :label="__('Department')">
                        <option :value="null" />
                        <option v-for="d in departments" :key="d.id" :value="d.id">{{ __(d.name) }}</option>
                    </select-input>

                    <select-input v-model="form.role_id" :error="form.errors.role_id" class="pb-8 pr-6 w-full lg:w-1/2"
                        :label="__('Role')">
                        <option :value="null" />
                        <option v-for="(r, ri) in roles" :key="ri" :value="r.id">{{ r.name }}</option>
                    </select-input>

                    <text-input v-model="form.password" :error="form.errors.password" class="pb-8 pr-6 w-full lg:w-1/3"
                        type="password" autocomplete="new-password" :label="__('Password')" />

                    <file-input v-model="form.photo" :error="form.errors.photo" class="pb-8 pr-6 w-full lg:w-1/2"
                        type="file" accept="image/*" :label="__('Photo')" />
                </div>
                <div class="flex items-center justify-end px-8 py-4 bg-gray-50 border-t border-gray-100">
                    <loading-button :loading="form.processing" class="btn-indigo" type="submit">{{ __('Create') }} {{
                        __('User') }}</loading-button>
                </div>
            </form>
        </div>
    </div>
</template>

<script>
import { Head, Link } from '@inertiajs/vue3'
import Layout from '@/Shared/Layout'
import FileInput from '@/Shared/FileInput'
import TextInput from '@/Shared/TextInput'
import SelectInput from '@/Shared/SelectInput'
import LoadingButton from '@/Shared/LoadingButton'

export default {
    components: {
        FileInput,
        Head,
        Link,
        LoadingButton,
        SelectInput,
        TextInput,
    },
    layout: Layout,
    props: {
        countries: Array,
        cities: Array,
        departments: Array, // Add this
        title: String,
        roles: Array,
    },
    remember: 'form',
    data() {
        return {
            form: this.$inertia.form({
                first_name: '',
                last_name: '',
                phone: '',
                email: '',
                city: null,
                address: '',
                country_id: null,
                department_id: null, // Add this
                role_id: null,
                password: '',
                photo: null,
            }),
        }
    },
    created() {
        // this.setDefaultValue(this.countries, 'country_id', 'United States')
    },
    methods: {
        setDefaultValue(arr, key, value) {
            const find = arr.find(i => i.name.match(new RegExp(value + ".*")))
            if (find) {
                this.form[key] = find['id']
            }
        },
        store() {
            this.form.post(this.route('users.store'))
        },
    },
}
</script>
